import React from "react";

import FormInput from "../../Inputs/FormInput";
import FormSelect from "../../Inputs/FormSelect";

import styles from "./pageModal.module.css";

const GenericPageModalForm = ({
  formSections,
  formData,
  errors,
  readOnly,
  getFieldLabel,
  normalizeSelectValue,
  handleChange,
}) =>
  formSections.map((section, sectionIndex) => (
    <div
      key={`section-${section.title || "default"}-${sectionIndex}`}
      className={styles.formSection}
    >
      {section.title && <h3 className={styles.sectionTitle}>{section.title}</h3>}

      <div className={styles.formGrid}>
        {section.fields.map((field) => {
          if (field.type === "select") {
            return (
              <FormSelect
                key={field.name}
                label={getFieldLabel(field)}
                name={field.name}
                value={formData[field.name] || ""}
                options={field.options || []}
                error={errors[field.name]}
                disabled={readOnly || field.disabled}
                onChange={(e) =>
                  handleChange(field.name, normalizeSelectValue(field, e.target.value))
                }
              />
            );
          }

          return (
            <FormInput
              key={field.name}
              label={getFieldLabel(field)}
              name={field.name}
              type={field.type}
              decimalPlaces={field.type === "number" ? 2 : undefined}
              error={errors[field.name]}
              accept={
                field.type === "file" ? ".png,.jpg,.jpeg,application/pdf" : undefined
              }
              value={field.type !== "file" ? formData[field.name] || "" : undefined}
              disabled={readOnly || field.disabled}
              onChange={(e) => {
                if (field.type === "file") {
                  handleChange(field.name, e.target.files[0]);
                } else {
                  handleChange(field.name, e.target.value);
                }
              }}
            />
          );
        })}
      </div>
    </div>
  ));

export default GenericPageModalForm;
